import createTheme from "@mui/material/styles/createTheme";
import { Theme } from "@mui/material/styles";

import "@fontsource/montserrat"; // Defaults to weight 400
import "@fontsource/montserrat/400.css"; // Specify weight
import "@fontsource/montserrat/400-italic.css"; // Specify weight and style
import { muiTypographyTheme } from "./typography-theme";
import { muiTextFieldTheme } from "./textfield-theme";
import { getPalette } from "./palette";
import { muiSnackBarContentTheme } from "./snackBarTheme";
import { ThemeMode } from "./themeMode";

declare module "@mui/material/styles" {
  interface Palette {
    primary: PaletteColor;
    secondary: PaletteColor;
    error: PaletteColor;
    grey2: PaletteColor;
    complementary: PaletteColor;
    orange: PaletteColor;
    yellow: PaletteColor;
    transparency: PaletteColor;
    wizardText: PaletteColor;
  }

  // allow configuration using `createTheme`
  interface PaletteOptions {
    primary?: PaletteColorOptions;
    secondary?: PaletteColorOptions;
    error?: PaletteColorOptions;
    grey2?: PaletteColorOptions;
    complementary?: PaletteColorOptions;
    orange?: PaletteColorOptions;
    yellow?: PaletteColorOptions;
    transparency?: PaletteColorOptions;
    wizardText?: PaletteColorOptions;
  }

  interface PaletteColor {
    main: string;
    dark: string;
    darker?: string;
    moreDarker?: string;
    darkest?: string;
    light: string;
    lighter?: string;
    moreLighter?: string;
    lightest?: string;
    contrastText: string;
    lightest2?: string;
  }

  interface PaletteColorOptions {
    main?: string;
    dark?: string;
    darker?: string;
    moreDarker?: string;
    darkest?: string;
    light?: string;
    lighter?: string;
    moreLighter?: string;
    lightest?: string;
    contrastText?: string;
    lightest2?: string;
  }
}

const spacingStyles = (theme: Theme, spacingTypesLength = 0, spacingKeyLabel = "spacing-xs") => {
  const hashMap = {} as any;
  new Array(spacingTypesLength)
    .fill(0)
    .map((_, index) => {
      return {
        spacing: index + 1,
        themeSpacingValue: theme.spacing(index + 1),
      };
    })
    .map(({ spacing, themeSpacingValue }) => {
      themeSpacingValue = themeSpacingValue.replace(/\D/g, "");
      hashMap[`${spacingKeyLabel}-${spacing}`] = {
        margin: `-${themeSpacingValue}px`,
        width: `calc(100% + ${(themeSpacingValue as any) * 2}px)`,
        "> .MuiGrid-item": {
          padding: themeSpacingValue + "px",
        },
      };
      return true;
    });
  return hashMap;
};

export const getTheme = (mode: ThemeMode = "dark"): Theme => {
  let theme = createTheme();

  theme = createTheme(theme, {
    components: {
      MuiGrid: {
        styleOverrides: {
          ...spacingStyles(theme, 10),
        },
      },
      MuiTextField: muiTextFieldTheme,
      MuiTypography: {
        ...muiTypographyTheme.MuiTypography,
        styleOverrides: {
          root: {
            transition: "color 0.4s ease",
          },
        },
      },
      MuiLink: muiTypographyTheme.MuiLink,
      MuiSnackbarContent: muiSnackBarContentTheme,
    },
    typography: muiTypographyTheme.typography,
    palette: getPalette(mode),
  });
  return theme;
};

export interface CustomTheme extends Theme {
  themeName?: string;
}

export type ThemeInterface = CustomTheme;
